export default __webpack_public_path__ + "static/media/acct-payroll-report.5ef68967.png";